<template>
  <div class="FlightSelector">
    <!-- <header class="FlightSelectorHeader">
      <h5 class="FlightSelectorHeader--legTitle">{{ `${$t('leg')} ${id}` }}</h5>
    </header> -->
    <i v-if="$breakpoint.isDesktop" class="fa fa-grip-vertical handle"></i>
    <autocomplete-airport
      v-model="origin"
      :name="`origin_${id}`"
      :label="$t('origin')"
      placeholder="origin"
      icon-class="fas fa-plane"
      :full-list="true"
      :airports="getOriginAirports"
      :display="displayTarget"
      :ref="`origin_${id}`"
      class="--origin"
    ></autocomplete-airport>
    <button
      v-if="!$breakpoint.isMobile"
      @click="swapRouter"
      class="IconButton"
      :class="{
        'overlap': $breakpoint.isMobile,
        'radius': !$breakpoint.isMobile
      }"
    >
      <i class="fa-solid fa-arrow-right-arrow-left"></i>
    </button>
    <autocomplete-airport
      v-model="destination"
      :label="$t('destination')"
      :name="`destination_${id}`"
      placeholder="destination"
      icon-class="fas fa-map-marker-alt"
      :airports="getDestinationAirports"
      :full-list="true"
      :display="displayTarget"
      @search-dates="getDatesAvailable"
      :ref="`destination_${id}`"
    ></autocomplete-airport>
    <datepicker-controller
      :isRoundTrip="false"
      :isDoubleDatepicker="false"
      ref="multicity_datepicker"
      :key="`multicity_datepicker_${id}`"
      :dates="dates"
      :initial-value="null"
      v-model="dateSelected"
      :show-input-label="false"
      :open-date-picker="true"
    >
    </datepicker-controller>
    <button v-if="showDelete"
      class="IconButton radius delete"
      @click="$emit('onDelete')"
    >
      <i class="fa-solid fa-x"></i>
    </button>
  </div>
</template>

<script>
import AutocompleteAirport from '.././AutocompleteAirport'
import DatepickerController from '.././DatepickerController'
import aiportMixin from '../helpers/airportHelper'
export default {
  name: "MulticityFlightSelector",
  components: {
    AutocompleteAirport,
    DatepickerController
  },
  mixins: [aiportMixin],
  props: {
    id: null,
    bookingData: null,
    displayTarget: null,
    flight: null,
    showDelete: null
  },
  data () {
    return {
      dateSelected: null
    }
  },
  watch: {
    selectedFlight: function (flight) {
      this.$emit('onFlightSelected', flight)
    },
    flight: function (newF) {
      this.origin = newF.origin
      this.destination = newF.destination
      this.dateSelected = newF.date
    }
  },
  computed: {
    selectedFlight: function () {
      return {
        origin: this.origin,
        destination: this.destination,
        date: this.dateSelected
      }
    }
  },
  methods: {
    swapRouter: function() {
      const originSwap = this.origin
      this.origin = this.destination
      this.destination = originSwap
    }
  }
}

</script>
<style lang="sass" scoped>
.FlightSelector
  display: flex
  flex-wrap: wrap
  gap: .5rem
  align-items: baseline
  // justify-content: space-between
  &Header
    flex: 1 1 100%
  &--legTitle
    color: var(--color-primary)
  .handle
    color: var(--color-overlay-40)
.IconButton
  all: unset
  display: flex
  height: 2.5rem
  width: 2.5rem
  align-self: flex-end
  align-items: center
  justify-content: center
  z-index: 99999
  background-color: var(--color-surface)
  border: 1px solid var(--color-overlay-20)
  cursor: pointer
  &.radius
    border-radius: 100%
    background-color: var(--color-overlay-02)
    border: none
    color: var(--color-overlay-40)
    // align-self: center
  &.delete
    margin-left: auto
  &.overlap
    margin-top: -1.5rem
    margin-bottom: -1.5rem
    margin-left: 75%
  
// tablet
@media (min-width: 768px)
  .FlightSelector
    flex-direction: row
    .datepickerController,
    .autocompleteAirport
      flex-basis: calc(50% - 2rem)
  .IconButton
    margin: 0
    align-self: baseline
    // border-radius: 100%


@media (min-width: 1024px)
  .FlightSelector
    .datepickerController
      width: 100%
    .autocompleteAirport,
    .datepickerController
      flex-basis: calc( 33% - 2.5rem )

</style>
<style lang="sass">
.FlightSelector
  .autocompleteAirport .inputText__input
    padding-right: 25% !important
  .datepickerController
    width: 70%
</style>